const guiColors = {
    'motion-primary': '#e6a817',
    'motion-primary-transparent': '#e6a817e6',
    'motion-tertiary': '#b8860b',

    'looks-secondary': '#e6a817',
    'looks-transparent': '#e6a81759',
    'looks-light-transparent': '#e6a81726',
    'looks-secondary-dark': 'hsla(42, 89%, 38%, 1)',

    'extensions-primary': 'hsla(42, 89%, 55%, 1)',
    'extensions-tertiary': 'hsla(30, 85%, 40%, 1)',
    'extensions-transparent': 'hsla(42, 89%, 55%, 0.35)',
    'extensions-light': 'hsla(48, 90%, 85%, 1)',

    'drop-highlight': '#ffd54f',

    'menu-bar-background-image':
        'linear-gradient(90deg, ' +
        'rgba(255, 213, 79, 0.75) 0%, ' +
        'rgba(230, 168, 23, 0.75) 50%, ' +
        'rgba(184, 134, 11, 0.75) 100%)'
};

const blockColors = {
    checkboxActiveBackground: '#e6a817',
    checkboxActiveBorder: '#b8860b'
};

export {
    guiColors,
    blockColors
};
